//FormComponent & ValidationSettings

import { ElementRef } from '@angular/core';
import { Product } from './Product';
import { NgForm } from '@angular/forms';
import { ProductValidatorService, Validation, ValidationErrorSettings, ValidationAlertSettings } from "../services/validators/product-validator.service";
import * as $ from 'jquery';

export abstract class FormComponent {
  product:Product;
  formElement:ElementRef;
  formData:NgForm;
  productValidator:ProductValidatorService;
  validationErrorSettings: ValidationErrorSettings;
  validationAlertSettings?: ValidationAlertSettings;
  get fieldId():string { return '#'+this.formData.name }
  get fieldValue():string { return this.formData.value as string }

  constructor() { }

  //Init for Sub.  Note - must be called in onInit or after.  (child's constructor won't have formElement intitialized; will be created just before onInit)
  //  It also registers the component with the Validator service, so that parent component 'form' for product-add/edit can access the child form-components for validation.
  //  optionally, caller provides 'alertType' if it wants to show an alert using one of the AlertType functions in productValidatorService.
  initParent(product:Product, formElement:ElementRef, formData:NgForm, productValidator:ProductValidatorService, validationErrorSettings:ValidationErrorSettings, validationAlertSettings?:ValidationAlertSettings){
    this.product = product;
    this.formElement = formElement;
    this.formData = formData;
    this.productValidator = productValidator;
    this.validationErrorSettings = validationErrorSettings;
    this.validationAlertSettings = validationAlertSettings;

    this.productValidator.registerFormComponent(this);
  }

  //====================
  //User Interactions

  onFormBlur($e){
    let fieldValue = $e.target.value as string;
    this.onFormChange(fieldValue);
  }


  onFormChange($e){
    //allow form to be updated with new model value
    setTimeout( () => {
      this.performValidations();
    }, 0);
  }


  //=======================
  //Validations

  private performValidations(){
    //reset validations
    this.hideErrorAndAlertViews();
    this.productValidator.resetValidationForField(this.fieldId);

    //perform new validations for error & optionally alert
    this.validateForError((errorResult) => {
      this.configureErrorView(errorResult);
      let noError = (errorResult.success == true);
      if (this.validationAlertSettings!==undefined && noError){
        this.validateForAlert((alertResult) => {
          this.configureAlertView(alertResult);
          this.alertCallback(alertResult);  //callback to subclass (to optionally hide the alert)
        });
      }        
    });
  }

  private validateForError(callback?){
    let settings = this.validationErrorSettings;
    let result = this.productValidator.validateForError(this, this.validationErrorSettings);
    callback ? callback(result) : null;
  }

  private validateForAlert(callback?){
    let validateAlertFunction = this.validationAlertSettings.validateAlertFunction;
    let result = validateAlertFunction(this, this.validationAlertSettings);
    // let result:Validation = this.productValidator.validateForAlertFunction(this, this.validationAlertSettings);
    callback ? callback(result) : null;
  }

  //This is meant to be OPTIONALLY overloaded by subclass, to give it a chance to hide alerts (such as for ape-price).
  protected alertCallback(result:Validation){
    // console.log('superclass alertCallback.  do nothing');
    return null;
  }

  //=======================
  //Error & Alert Views

  private hideErrorAndAlertViews(){
    let errorElementId = this.fieldId+'Error';
    let alertElementId = this.fieldId+'Alert';
    $(errorElementId).hide();
    $(alertElementId).hide();
  }

  public hideAlertView(){
    let alertElementId = this.fieldId+'Alert';
    $(alertElementId).hide();
  }


  private configureErrorView(errorResult:Validation){
    let errorElementId = this.fieldId+'Error';

    //show error, only after initial touch
    if(this.formData.touched && errorResult.success == false){
      $(errorElementId).html(errorResult.message);
      $(errorElementId).show();
    }

  }

  //note: only call this when sku is valid
  private configureAlertView(alertResult:Validation) {
    let alertElementId = this.fieldId+'Alert';

    //always show alert when configuring this view
    $(alertElementId).show();
    //alert message
    $(alertElementId).html(alertResult.message);
    //alert style
    if(alertResult.success) { $(alertElementId).removeClass( "alert-danger").addClass( "alert-success") } 
    else { $(alertElementId).removeClass( "alert-success" ).addClass( "alert-danger") }
  }


  //================
  //PUBLIC: Parent Validation Trigger

  public triggerValidationsforParent(showErrorsAndAlerts:boolean){
    //'touch' the form by focus and blur on the input field
    //  so that alerts/error divs will show
    if(showErrorsAndAlerts && this.formData.untouched){
      this.formElement.nativeElement.focus();
      this.formElement.nativeElement.blur();
    }
    this.performValidations();
  }

}




//=================
//Unused Code

//Required Classes - derived classes must implement
// abstract triggerValidationsforParent(showErrorsAndAlerts:boolean): void;  




// WEBPACK FOOTER //
// ./src/app/models/FormComponent.ts